import React, { useRef } from "react";
import "./AvailableLibraries.scss";
import { OutsideClickHandler } from "../../utils";

export default function AvailableLibraries(props) {
  const {
    searchedList,
    libraryAddedToSlides,
    showSearchResult,
    showResultCallBack,
    localLibrary,
    sharedLibrary
  } = props;
  const searResultsRef = useRef();

  OutsideClickHandler(searResultsRef, showResultCallBack, showSearchResult);
  return (
    <div className="libraries-wrapper" ref={searResultsRef}>
      {searchedList.map((list, index) => (
        <div className="library-details" key={index}>
          <div className="library-name">{list.name}</div>
          <div className="library-source">
            <div
              className={`local-library library ${localLibrary.find(lib => lib._id === list._id) ? 'highlightPresent' : ''}`}
              onClick={() => libraryAddedToSlides(list, "local")}
            >
              Local
            </div>
            <div
              className={`shared-library library ${sharedLibrary.find(lib => lib._id === list._id) ? 'highlightPresent' : ''}`}
              onClick={() => libraryAddedToSlides(list, "shared")}
            >
              Shared
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
